import { GqlDispensaries } from 'types/graphql';

type GetProductInventoryFiltersArgs = {
  dispensary?: GqlDispensaries;
  isKiosk: boolean;
};

type GetProductInventoryFiltersReturn = {
  removeZeroManualInventory: boolean;
  removeZeroLimitsPerCustomer: boolean;
  removeBelowOnlineIntegrationThreshold: boolean;
  removeBelowKioskIntegrationThreshold: boolean;
};

export function getProductInventoryFilters({
  dispensary,
  isKiosk,
}: GetProductInventoryFiltersArgs): GetProductInventoryFiltersReturn {
  const removeZeroManualInventory = !dispensary?.hasMenuIntegration;
  const removeZeroLimitsPerCustomer = Boolean(dispensary?.storeSettings.enableLimitPerCustomer);
  const removeBelowOnlineIntegrationThreshold = Boolean(!isKiosk && dispensary?.hasMenuIntegration);
  const removeBelowKioskIntegrationThreshold = Boolean(isKiosk && dispensary?.hasMenuIntegration);

  return {
    removeZeroManualInventory,
    removeZeroLimitsPerCustomer,
    removeBelowOnlineIntegrationThreshold,
    removeBelowKioskIntegrationThreshold,
  };
}
